var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlookLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#0364b8;}.cls-3,.cls-8{fill:#0a2767;}.cls-4{fill:#28a8ea;}.cls-5{fill:#35b8f1;}.cls-6{fill:#50d9ff;}.cls-7{fill:#0078d4;}.cls-11,.cls-8{opacity:0.5;}.cls-9{fill:#1490df;}.cls-10{opacity:0.1;}.cls-12{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outlook_24x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlook"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_24",
    "data-name": 24
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21,1H8A1,1,0,0,0,7,2V3l8,2.45L22,3V2A1,1,0,0,0,21,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24,11.92a.54.54,0,0,0-.26-.46h0L15.13,6.56A.41.41,0,0,0,15,6.49a1.23,1.23,0,0,0-1.06,0h0a.41.41,0,0,0-.11.07L5.28,11.43h0a.53.53,0,0,0,0,.91h0l8.59,4.93.11.06h0a1.15,1.15,0,0,0,1.06,0l.11-.06,8.59-4.9h0A.53.53,0,0,0,24,11.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "15 3 7 3 7 10 15 18 22 18 22 10 15 3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "23.56 22.82 5.29 12.37 5.28 12.37"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 15,
    y: 3,
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 7,
    y: 10,
    width: 8,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M14.5,19.5,5.29,12.35l.49-.86,8.61,4.94a.34.34,0,0,0,.24,0l8.5-4.85.5.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "13.85 17.27 13.88 17.28 13.85 17.27 13.85 17.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M23.74,12.36h0L15.2,17.25l-.17.08a1.23,1.23,0,0,1-.54.13,1.15,1.15,0,0,1-.53-.13l2.77,3.85,6.83,1.63A1,1,0,0,0,24,22V11.9A.56.56,0,0,1,23.74,12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M24,22v-.07l-8.5-4.85-.3.18-.17.09a1.33,1.33,0,0,1-.53.12h-.07a1.24,1.24,0,0,1-.43-.11v0L18,21l5.56,1.81A1,1,0,0,0,24,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.85,17.27,7,13.19H7l-1.74-.83h0A.53.53,0,0,1,5,11.9V22a1,1,0,0,0,1,1H22.8a1.16,1.16,0,0,0,.76-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M13.6,20A1.5,1.5,0,0,0,15,18.65V7.17A1.18,1.18,0,0,0,13.83,6H7v4.47l-1.74,1h0a.47.47,0,0,0-.26.42s0,0,0,0H5V20Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Back_Plate",
    "data-name": "Back Plate",
    className: "cls-7",
    y: 5,
    width: 14,
    height: 14,
    rx: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3.46,9.83A3.59,3.59,0,0,1,4.87,8.28,4.27,4.27,0,0,1,7.1,7.72a4,4,0,0,1,2.07.53,3.62,3.62,0,0,1,1.37,1.48A5,5,0,0,1,11,11.92a5,5,0,0,1-.49,2.28,3.6,3.6,0,0,1-1.41,1.53A4,4,0,0,1,7,16.28a4,4,0,0,1-2.11-.54,3.55,3.55,0,0,1-1.39-1.48A4.73,4.73,0,0,1,3,12.1,5.15,5.15,0,0,1,3.46,9.83ZM5,13.48a2.31,2.31,0,0,0,.79,1A2.07,2.07,0,0,0,7,14.87a2.16,2.16,0,0,0,1.31-.38,2.22,2.22,0,0,0,.77-1A3.78,3.78,0,0,0,9.32,12a4.45,4.45,0,0,0-.23-1.45,2.32,2.32,0,0,0-.75-1.06A2,2,0,0,0,7,9.13a2.16,2.16,0,0,0-1.27.37,2.36,2.36,0,0,0-.8,1A3.69,3.69,0,0,0,4.69,12,3.81,3.81,0,0,0,5,13.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookLogo);
export default __webpack_public_path__ + "static/media/outlook-logo.541250fe2542de4139adf415524b936a.svg";
export { ForwardRef as ReactComponent };